import { useCallback } from 'react';
import { Colors, Flex, IconChevronRight, Typography } from '@banhala/ui-kit';
import { bridge, isNil } from 'shared/src/utils';
import Svg, { Ellipse, Path } from 'react-native-svg';
import { useAiFittingRedirectPath } from './queries/useAiFittingRedirectPath';

interface AiFittingRoomBannerProps {
  entryPoint: 'GOODS_DETAIL_REVIEW' | 'GOODS_DETAIL_SIZE';
  tab: string;
}

export const AiFittingRoomBanner = ({
  entryPoint,
  tab,
}: AiFittingRoomBannerProps) => {
  const { data: aiFittingPath } = useAiFittingRedirectPath(entryPoint);

  const onPressButton = useCallback(() => {
    if (isNil(aiFittingPath)) return;
    if (isNil(aiFittingPath.deeplink)) return;

    bridge.logAnalyticsEvent({
      name: 'CLICK_AI_FITTING',
      channel: ['ablylog', 'amplitude'],
      analytics: {
        ...aiFittingPath.logging?.analytics,
        SCREEN: 'GOODS_DETAIL',
        TAB: tab,
      },
    });
    bridge.openDeeplink(aiFittingPath.deeplink);
  }, [aiFittingPath, tab]);

  if (isNil(aiFittingPath)) return null;
  if (isNil(aiFittingPath.deeplink)) return null;

  return (
    <Flex padding={{ horizontal: 16 }}>
      <Flex.Row
        padding={{ vertical: 8, horizontal: 12, right: 0 }}
        onPress={onPressButton}
        justifyContent={'space-between'}
        alignItems={'center'}
        borderRadius={8}
        borderWidth={1}
        borderColor={'border_secondary'}
      >
        <Flex.Row alignItems={'center'} gap={4}>
          <Svg width={24} height={24} viewBox="0 0 24 24">
            <Path
              d="M15.1181 4L12.0167 4L8.9154 4L3.69253 6.61145C3.14269 6.88637 2.9015 7.54193 3.14292 8.10526L4.15595 10.469C4.39215 11.0201 5.01142 11.2973 5.58175 11.1072L6.43427 10.823L6.43427 18.9747C6.43427 19.6119 6.94952 20.1271 7.58676 20.1271L12.094 20.1271L16.4724 20.1271C17.1151 20.1271 17.6368 19.6033 17.634 18.9606L17.5992 10.823L18.4482 11.106C19.0197 11.2965 19.6433 11.0155 19.8812 10.4604L20.8916 8.10302C21.1328 7.54017 20.8952 6.88852 20.3491 6.61548L15.1181 4Z"
              fill="#FF7E89"
            />
            <Path
              d="M8.91553 4L12.0169 7.10137L10.0461 7.49554C9.46038 7.61268 8.91553 7.16643 8.91553 6.56959L8.91553 4Z"
              fill="white"
            />
            <Path
              d="M15.1181 4L12.0167 7.10137L13.9804 7.49412C14.5681 7.61166 15.118 7.16041 15.118 6.56063L15.1181 4Z"
              fill="white"
            />
            <Ellipse
              cx="12.0166"
              cy="9.58251"
              rx="0.620273"
              ry="0.620275"
              fill="white"
            />
          </Svg>
          <Typography type={'subtitle2'}>
            이 옷, 내 몸엔 어떤 핏일까?
          </Typography>
        </Flex.Row>
        <Flex.Row gap={4} padding={{ horizontal: 12, vertical: 8 }}>
          <Typography type={'body3'} color={'content_secondary'}>
            바로입기
          </Typography>
          <IconChevronRight size={16} fill={Colors.content_secondary} />
        </Flex.Row>
      </Flex.Row>
    </Flex>
  );
};
